import styled from 'styled-components'

export const Footer = styled.footer`
background-color: #1b1101;
color: #ffffff;
display: flex;
justify-content: space-evenly;
padding-bottom: 1.5rem;
@media (min-width: 201px) and (max-width: 500px) {
flex-direction: column;
}
`
export const SectionLocal = styled.section`
display: flex;
flex-direction: column;
width: 45%;
height: 100%;
justify-content: space-evenly;
margin-top: 1rem;
h2 {
    font-weight: 900;
}
hr {
    opacity: 0.3;
}
@media (min-width: 201px) and (max-width: 500px) {
margin-top: 1rem;
margin-left: 1rem;
width: 90%;
}
@media (min-width: 501px) and (max-width: 900px) {
    font-size: 1.1rem;
    height: 15vh;
}
`
export const DivTextLocal = styled.div`
display: flex;
align-items: center;
justify-content: space-evenly;
margin-top: 0.5rem;
svg {
    margin-top: 0.2rem;
}
p {
    font-size: 1.2rem;
    margin-left: 0.5rem;
}
@media (min-width: 201px) and (max-width: 500px) {
svg {
    margin-top: 0;
    margin-bottom: 1.5rem;
    position: relative;
    left: 0.5rem;
}
}
@media (min-width: 501px) and (max-width: 900px) {
    p {
        font-size: 1.15rem;
    }
}
`
export const PRua = styled.p`
width: 100%;
@media (min-width: 201px) and (max-width: 500px) {
width: 85%;
}
@media (min-width: 501px) and (max-width: 900px) {
    width: 60vw;
}
`
export const SectionContato = styled.section`
display: flex;
flex-direction: column;
justify-content: space-evenly;
width: 45%;
margin-top: 1rem;
p {
    margin-top: 0.5rem;
}
hr {
    opacity: 0.3;
}
@media (min-width: 201px) and (max-width: 500px) {
margin-left: 1rem;
width: 90%;
}
@media (min-width: 501px) and (max-width: 900px) {
width: 35%;
}
`
export const TituloContato = styled.h2`
font-weight: 900;
`
export const DivEmail = styled.div`
display: flex;
align-items: center;
justify-content: flex-start;
svg {
    margin-top: 0.7rem;
}
p {
    font-size: 1.2rem;
    margin-left: 0.5rem;
}
@media (min-width: 201px) and (max-width: 500px) {
font-size: 0.8rem;
}
@media (min-width: 501px) and (max-width: 900px) {

}
`
export const DivTel = styled.div`
display: flex;
align-items: center;
justify-content: flex-start;
svg {
    margin-top: 0.7rem;
}
p {
    font-size: 1.2rem;
    margin-left: 0.5rem;
}
@media (min-width: 201px) and (max-width: 500px) {
    font-size: 0.8rem;
}
@media (min-width: 501px) and (max-width: 900px) {
}
`
export const DivInsta = styled.div`
display: flex;
align-items: center;
justify-content: flex-start;
svg {
    margin-top: 0.7rem;
    
}
p {
    font-size: 1.2rem;
    margin-left: 0.5rem;
}
@media (min-width: 201px) and (max-width: 500px) {
font-size: 0.8rem
}
`
export const Links = styled.section`
margin-top: 1rem;
display: flex;
justify-content: flex-start;
gap: 10px;
:hover {
    transition: 0.2s;
    background-color: white;
    svg path {
        fill: #000000;
    }
}
`
export const DivLinkInsta = styled.div`
transition: 0.2s;
border: solid white;
border-radius: 20px;
width: 6%;
height: 5vh;
display: flex;
justify-content: center;
align-items: center;
cursor: pointer;
svg {
    position: relative;
    top: 0.1rem;
}
@media (min-width: 201px) and (max-width: 500px) {
    width: 10%;
}
@media (min-width: 501px) and (max-width: 900px) {
width: 15%;
height: 3vh;
}
`
export const DivLinkZap = styled.div`
transition: 0.2s;
border: solid white;
border-radius: 20px;
width: 6%;
height: 5vh;
display: flex;
justify-content: center;
align-items: center;
cursor: pointer;
svg {
    position: relative;
    top: 0.05rem;
}
@media (min-width: 201px) and (max-width: 500px) {
    width: 10%;
}
@media (min-width: 501px) and (max-width: 900px) {
width: 15%;
height: 3vh;
}
`
export const Img = styled.img`
width: 14%;
cursor: pointer;
position: relative;
top: 0.6rem;
right: 0.2rem;
@media (min-width: 201px) and (max-width: 500px) {
width: 9vw;
}
@media (min-width: 501px) and (max-width: 900px) {
    width: 7vw;
}
`
export const ImgI = styled.img`
width: 11%;
cursor: pointer;
position: relative;
top: 0.5rem;
@media (min-width: 201px) and (max-width: 500px) {
width: 8.65vw;
}
@media (min-width: 501px) and (max-width: 900px) {
    width: 6.40vw;
}
`
export const A = styled.a`
border-radius: 20px;
`
export const SectionCopyright = styled.section`
background-color: #1b1101;
color: white;
p {
    text-align: center;
    font-weight: bold;
    font-size: 1.3rem; 
}
hr {
    opacity: 0.1;
}
@media (min-width: 201px) and (max-width: 500px) {
}
p {
    margin-left: 0.5rem;
    margin-top: 0.5rem;
    font-size: 1rem;
}
@media (min-width: 501px) and (max-width: 900px) {
p {
    font-size: 1.2rem;
}
}
`

